import PropTypes from 'prop-types';

const profilePropTypes = {
  profile: PropTypes.shape({
    givenName: PropTypes.string.isRequired,
    balances: PropTypes.shape({
      points: PropTypes.number.isRequired,
    }).isRequired,
  }),
  handleSignOut: PropTypes.func.isRequired,
  dark: PropTypes.bool,
};

const profileDefaultProps = {
  profile: null,
  dark: true,
};

export { profilePropTypes, profileDefaultProps };
